<template>
  <div class="vehicleBindingRecord-container">
    <el-form
      size="medium"
      :inline="true"
      :model="queryForm"
      ref="queryForm"
      class="input-form-inline"
      @submit.native.prevent
    >
      <div>
        <el-form-item class="r-20" prop="vin">
          <el-input
            v-model.trim="queryForm.vin"
            @keyup.enter.native="query"
            placeholder="车架号"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="plateNum">
          <el-input
            v-model.trim="queryForm.plateNum"
            @keyup.enter.native="query"
            placeholder="车牌号"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="user">
          <el-input
            v-model.trim="queryForm.user"
            @keyup.enter.native="query"
            placeholder="使用人"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="operationsId">
          <el-select
            v-model="queryForm.operationsId"
            placeholder="选择操作内容"
          >
            <el-option
              v-for="item in operationsList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-button
          v-if="hasPerm('device:replace:list')"
          type="primary"
          @click="query"
          >查询</el-button
        >
        <el-button v-if="hasPerm('device:replace:list')" @click="reset"
          >取消</el-button
        >
      </div>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      size="mini"
      stripe
      height="560px"
    >
      <el-table-column
        width="40"
        align="center"
        style="padding: 0"
      ></el-table-column>
      <el-table-column type="index" label="序号" width="55"></el-table-column>
      <el-table-column
        prop="vin"
        label="车架号"
        min-width="120"
      ></el-table-column>
      <el-table-column prop="plateNum" label="车牌号"></el-table-column>
      <el-table-column prop="user" label="使用人"></el-table-column>
      <el-table-column prop="phone" label="联系电话"></el-table-column>
      <el-table-column
        prop="type"
        label="操作内容"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span v-if="row.type == 1">绑定车辆</span>
          <span v-else-if="row.type == 2">解绑车辆</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="time"
        label="操作时间"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="dept"
        label="使用部门"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: "VehicleBindingRecord",
  data() {
    return {
      queryForm: {
        vin: "",
        plateNum: "",
        user: "",
        operationsId: "",
      },
      tableData: [],
      operationsList: [
        { value: "2", label: "解绑车辆" },
        { value: "1", label: "绑定车辆" },
      ],
      total: 0,
      limit: 10,
      currentPage: 1,
    };
  },
  created() {
    this.getRecordList();
  },
  methods: {
    query() {
      this.getRecordList();
    },
    reset() {
      this.$resetForm(this, "queryForm");
      this.getRecordList();
    },
    async getRecordList() {
      let _this = this;
      let obj = {};
      obj.vin = _this.queryForm.vin;
      obj.plateNum = _this.queryForm.plateNum;
      obj.user = _this.queryForm.user;
      obj.type = _this.queryForm.operationsId;
      obj.limit = _this.limit;
      obj.page = _this.currentPage;
      let { data: res } = await _this.$axios.get("/api/device/bind/list", {
        params: obj,
      });
      if (res.code == 1) {
        _this.tableData = res.data.list;
        _this.total = res.data.totalCount;
      }
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getRecordList();
    },
  },
};
</script>

<style lang="scss" scoped>
.vehicleBindingRecord-container {
  height: calc(100% - 60px);
  margin: 20px;
  padding: 20px;
  padding-top: 0;
  background: #fff;
}
</style>
